// UNIT Ecosystem Design System values used by UGAIN. Source: _ds/…/tokens/*.css.
// Do not invent new colours; extend here only with values approved by Design.
export const C = {
  ink: '#0D0D12',
  night: '#0B0B0F',
  paper: '#F7F7F9',
  white: '#FFFFFF',
  grey: '#666672',
  border: '#D9D9DF',
  subtle: '#ECECF0',
  divider: '#F3F3F6',
  dark1: '#16161C',
  dark2: '#1A1A22',
  dark3: '#2A2A33',
  darkBorder: '#3A3A44',
  darkChip: '#33333D',
  mutedDark: '#A9B2BD',
  metal: '#D5DAE1',
  violet: '#5A46DE',
  violetPressed: '#4B39C9',
  mark: '#8B6DFF',
  rim: '#9D85FF',
  soft: '#F1EFFC',
  accentBorder: '#DCD7F7',
  green: '#0B7646',
  greenBg: '#E8F4EE',
  greenDark: '#4CC38A',
  amber: '#A85B08',
  amberBg: '#FFF3E0',
  amberBorder: '#F5D7A8',
  amberDark: '#F5B65C',
  red: '#B83128',
  redDark: '#F07A70',
} as const;

export const R = { pill: 999, hero: 28, card: 24, pulse: 20, panel: 16, thumb: 14, input: 12, chip: 5 } as const;

/** px → rem so text follows the user's browser / OS text-size setting. */
export const rem = (px: number): string => `${px / 16}rem`;

const SANS = 'Geist, system-ui, -apple-system, "Segoe UI", sans-serif';
const MONO = '"Geist Mono", ui-monospace, SFMono-Regular, Menlo, monospace';

/** CSS `font` shorthand helper. */
export const font = (weight: number, px: number, lineHeight: number | string = 1.2, family: 'sans' | 'mono' = 'sans'): string =>
  `${weight} ${rem(px)}/${lineHeight} ${family === 'mono' ? MONO : SANS}`;

export const STAGES = ['Idea', 'Planning', 'Scheduled', 'Live', 'Completed'] as const;

/** [label, background, foreground] per lifecycle stage. */
export const STAGE_CHIP: ReadonlyArray<readonly [string, string, string]> = [
  ['IDEA', C.divider, C.grey],
  ['PLANNING', C.amberBg, C.amber],
  ['SCHEDULED', C.soft, C.violet],
  ['LIVE', C.greenBg, C.green],
  ['COMPLETED', C.greenBg, C.green],
];

/** [on light, on dark] per health state. */
export const HEALTH_COLORS = {
  'On track': [C.green, C.greenDark],
  'Needs help': [C.amber, C.amberDark],
  Blocked: [C.red, C.redDark],
} as const;
